import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'utility-bar',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class UtilityBarComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  gotoHome(){
    this.router.navigate(['/home']);
  }

}
